import React, { Component } from 'react';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
  }

  scrollDown = () => {
    //TODO : implement scroll down
  }

  render() {
    return (
      <div className="App">
        <div className="App-title-heading">
          BLOCK WARS
        </div> 
          <div className="App-title-subtitle">
            Fortify, Attack, Win!
          </div>
          <div id="container"></div>          
          <div className="App-description">Map-based war game running on the Ethereum blockchain</div> 
          <div className="App-description-2">Fight with ether to win ether</div> 
          {/* <p style={{'font-weight':'', 'font-size': '24px', 'margin-left': '25px', 'margin-right': '25px', 'margin-top': '60px'}}>MAJOR UPDATE (June 7th): More power to the players, <a href="https://medium.com/@BlockWars/major-update-more-power-to-the-players-93dc7526f30" target="_blank">read more</a></p>           */}
          <br/><br/>
          <a href="https://play.blockwars.live">
            <input className="App-play-button" type="button" value="PLAY"/>
          </a>
          <br/><br/><br/>
          {/* <div style={{'display':'none'}}> */}
          {/* <code className="code-text" style={{'margin-left': '25px', 'margin-right': '25px'}}><a href="#raffle">Public audit phase 2 is over and in review - ends in</a>
          <p id="demo" style={{'font-weight':'bold', 'font-size': '40px', color:'#AD1457', 'margin-left': '25px', 'margin-right': '25px', 'margin-bottom': '0px', 'margin-top': '10px'}}></p></code> */}
          {/* </div> */}
          {/* <p style={{'font-weight':'', 'font-size': '20px', 'margin-left': '25px', 'margin-right': '25px'}}><a href="https://www.youtube.com/watch?v=EicAdBJ3-fU" target="_blank">YouTube livestream</a> from the <a href="https://www.meetup.com/decentralized-camp/events/250240555" target="_blank">launch event</a> May 7th 2018 (will be edited soon)</p> */}
          <div className="App-email-form">
            {/* Begin MailChimp Signup Form */}
            <div id="mc_embed_signup">
              <form action="https://live.us17.list-manage.com/subscribe/post?u=f6d736555e000bc523ae5baf6&id=34d43b5433" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
                <div id="mc_embed_signup_scroll">
                  <input type="email" name="EMAIL" className="email" id="mce-EMAIL" placeholder="E-mail address" required />
                  {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups*/}
                  <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true"><input type="text" name="b_f6d736555e000bc523ae5baf6_34d43b5433" tabIndex={-1} defaultValue /></div>
                  <div className="clear"><input type="submit" defaultValue="Keep me updated!" name="subscribe" id="mc-embedded-subscribe" className="button" /></div>
                </div>
              </form>
            </div>
            {/*End mc_embed_signup*/}
          </div>
          <div>
            <a href="#gameplay"><img className="scroll-down" src="https://www.nesevo.com/static/img/arrow-down-navigation.gif" alt="scroll down"/></a>            
            <a href="https://t.me/blockwars" target="_blank"><img src="img/telegram_48.png" width="35" height="35" className="social-img" /></a>
            <a href="https://discord.gg/gQ63F5r" target="_blank"><img src="img/discord-32.png" className="social-img" /></a>
            <a href="https://www.youtube.com/channel/UCEmXjrnb3MQpluu3uWhT6Ow" target="_blank"><img src="img/youtube.png" className="social-img" /></a>
            <a href="https://twitter.com/BlockWarsLive" target="_blank"><img src="img/twitter-3-32.png" className="social-img" /></a>
            <a href="https://www.facebook.com/BlockWars" target="_blank"><img src="img/facebook-3-32.png" className="social-img" /></a>
            <a href="https://medium.com/@BlockWars" target="_blank"><img src="img/medium-3-32.png" className="social-img" /></a>
            <a href="#gameplay"><img className="scroll-down" src="https://www.nesevo.com/static/img/arrow-down-navigation.gif" alt="scroll down"/></a>            
          </div>
        </div>
        
    );
  }
}


export default App;




// WEBPACK FOOTER //
// ./src/App.js